import { SyntheticEvent } from 'react';
import { useTheme } from '@mui/material/styles';
// material-ui
import { Alert, AlertTitle, Button, Fade, Grow, IconButton, Slide, SlideProps, SxProps, Theme } from '@mui/material';
import MuiSnackbar from '@mui/material/Snackbar';

// assets
import CloseIcon from '@mui/icons-material/Close';

import { KeyedObject } from 'types';
import { useDispatch, useSelector } from 'store';
import { closeSnackbar } from 'store/slices/snackbar';
import CustomConfirmDialog from './CustomConfirmDialog';
import { closeConfirmation } from 'store/slices/confirmation';

// animation function
function TransitionSlideLeft(props: SlideProps) {
    return <Slide {...props} direction="left" />;
}

function TransitionSlideUp(props: SlideProps) {
    return <Slide {...props} direction="up" />;
}

function TransitionSlideRight(props: SlideProps) {
    return <Slide {...props} direction="right" />;
}

function TransitionSlideDown(props: SlideProps) {
    return <Slide {...props} direction="down" />;
}

function GrowTransition(props: SlideProps) {
    return <Grow {...props} />;
}

// animation options
const animation: KeyedObject = {
    SlideLeft: TransitionSlideLeft,
    SlideUp: TransitionSlideUp,
    SlideRight: TransitionSlideRight,
    SlideDown: TransitionSlideDown,
    Grow: GrowTransition,
    Fade
};

const sxAlertOutlined = {
    bgcolor: 'background.paper'
};

const sxAlertFilledSuccess = {
    bgcolor: 'success.dark'
};
const sxAlertFilledError = {
    bgcolor: 'error.main'
};
const sxAlertFilledWarning = {
    bgcolor: 'warning.main'
};
// ==============================|| Confirmation ||============================== //

const Confirmation = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const confirmation = useSelector((state) => state.confirmation);
    const { title, open, children, setOpen, onConfirm,onClose, onCancel, showDontShowAgain  } =
    confirmation;

    const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        onCancel && onCancel();

        dispatch(closeConfirmation());
    };


    return (
        <>
        <CustomConfirmDialog
        title={title}
        open={open} 
        onConfirm={onConfirm}
        onCancel={onCancel}
        setOpen={setOpen}
        onClose={onClose}
        showDontShowAgain={showDontShowAgain}
        >{children}</CustomConfirmDialog>
           
        </>
    );
};

export default Confirmation;
